/* eslint-disable max-classes-per-file */

import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

import { Entrypoint } from './types';
/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when the Smart Collar modal appears
 *
 * &nbsp;
 */
export class SmartCollarModalAppeared extends AnalyticsEvent {
  eventName = 'smart-collar-modal-appeared';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.m_and_a;

  constructor(entrypoint: Entrypoint) {
    super({ entrypoint });
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when user clicks on the "Claim your tracker" primary button
 *
 * &nbsp;
 */
export class SmartCollarClaimButtonClick extends AnalyticsEvent {
  eventName = 'smart-collar-modal-claim-btn-click';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.m_and_a;

  constructor(entrypoint: Entrypoint) {
    super({ entrypoint });
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when user clicks on the "Cancel" button
 *
 * &nbsp;
 */
export class SmartCollarCancelButtonClick extends AnalyticsEvent {
  eventName = 'smart-collar-modal-cancel-btn-click';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.m_and_a;

  constructor(entrypoint: Entrypoint) {
    super({ entrypoint });
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when user clicks on the close button
 *
 * &nbsp;
 */
export class SmartCollarCloseButtonClick extends AnalyticsEvent {
  eventName = 'smart-collar-modal-close-btn-click';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.m_and_a;

  constructor(entrypoint: Entrypoint) {
    super({ entrypoint });
  }
}
